import { Typography } from '@material-ui/core'
import Container from '../components/layout/Container'

export default function AuthStatus(props) {
    return (
        <Container
            crumbs={props.crumbs}
            title={props.title}
        >
            <Typography variant="h5" gutterBottom>{props.text}</Typography>
        </Container>
    )
}